import { caseRoute } from '@/shared/domain/caseRoute';

/** Where a case opens. Pixie proposes the same destination a queue row leads to,
    so an action it offers and a row the operator clicks never disagree. */
export { caseRoute };

/** Reads the case in scope out of the URL. The panel sits above the route, so it
    cannot use useParams — it matches the path itself. */
export function caseIdFromPath(pathname: string): string | null {
  const hit = /^\/case\/([^/]+)/.exec(pathname);
  return hit?.[1] ?? null;
}
